import { memo } from 'react';
import Link from 'root/src/client/web/base/Link';
import DareDropLogo from 'root/src/client/public/logo-daredrop0.png';
export const Logo = memo(() => (
// @ts-ignore
<Link navStyle href="/" nextJs={false}>
		<img height="54" width="197" src={DareDropLogo.src} className="h-[54px]" alt="Dare Drop Logo"/>
	</Link>
// eslint-disable-next-line ramda/prefer-ramda-boolean
), () => true);
